import React, { createContext, useContext } from 'react';
import { useApi } from '../hooks/useApi';
import axios from "axios";
import { useJsforceRetrieve, getConnection } from '../hooks/useJsforce';
import apexAdapter from "../adapters/ApexAdapter";
import { translateNamespace } from "../hooks/useApexAdapter";
import { getSessionId, getParam, prepareInlineAdapter, loginRequest, getNamespace } from "../../";
import { Record, Result } from '../types';

import { initializeApp } from 'firebase/app';
import {
    getFirestore,
    collection,
    doc,
    getDoc,
    query,
    where,
    getDocs,
    limit,
    endAt,
    endBefore,
    startAt,
    startAfter,
} from "firebase/firestore";
import { firestoreConfig } from './config';

const DataContext = createContext(null);
let firebaseApp = null;
const DataProvider = ({children, type}) => {
    prepareInlineAdapter();
    if(type === "firebase"){
        firebaseApp = initializeApp(firestoreConfig);
    }
    return (
        <DataContext.Provider value={type}>
            {children}
        </DataContext.Provider>
    )
};
let msalInstance = null;
const useDataProvider = (record: Record, params: any, justData = false, callBack = null) => {
    let initialLimit = 10;
    if(params.hasOwnProperty("RF_LIMIT")){
        initialLimit = params.RF_LIMIT;
    }else if(record.hasOwnProperty("params") && record.params.hasOwnProperty("RF_LIMIT")){
        initialLimit = record.params.RF_LIMIT;
    }
    let initialOffset = 0;
    if(params.hasOwnProperty("RF_OFFSET")){
        initialOffset = params.RF_OFFSET;
    }else if(record.hasOwnProperty("params") && record.params.hasOwnProperty("RF_OFFSET")){
        initialOffset = record.params.RF_OFFSET;
    }
    let sendApiCall = true;
    if(params.hasOwnProperty("callApi")){
        sendApiCall = params.sendApiCall;
    }
    let context = useContext(DataContext);
    if(params.hasOwnProperty("provider") && params.provider.length > 0){
        context = params.provider;
        delete params['provider'];
    }
    if(!firebaseApp && context === "firebase"){
        firebaseApp = initializeApp(firestoreConfig);
    }
    const [state, setState] = React.useState<any>({
        loading: false,
        callApi: sendApiCall,
        RF_LIMIT: initialLimit,
        RF_OFFSET: initialOffset,
        viewMore: false,
        errors: null
    });
    type RecordType = typeof record;
    let [data, setData] = React.useState<Result>({
        numberOfResults: 0,
        statusCode: 200,
        result: null,
        nextKey: null
    });
    let getData = () => {

    };    
    switch(context){
        case 'salesforceapi':
            getData = () => {
                let offset = state.RF_OFFSET;
                let loading = true;
                let viewMore = false;
                if(offset){
                    loading = false;
                    viewMore = true;
                }
                setAdapterState({
                    loading: loading,
                    callApi: false,
                    viewMore: viewMore,
                    errors: null
                });
                callApi(context, record).then((data: Result) => {
                    const newState = {
                        loading: false,
                        callApi: false,
                        hasMore: false,
                        errors: null,
                        viewMore: false
                    };
                    setAdapterState(newState);
                    setData(data);
                    if(callBack !== null){
                        callBack(data);
                    }
                }).catch(err => {
                    setAdapterState({
                        loading: false,
                        callApi: false,
                        hasMore: false,
                        errors: err.response.data,
                        viewMore: false
                    });
                });
        
                window.dispatchEvent(new Event("remoteAction"));
            }
            break;
        case 'apexadapter':
            getData = () => {
                const limit = state.RF_LIMIT;
                const offset = state.RF_OFFSET;
                const resultObj: Result = {
                    numberOfResults: 0,
                    statusCode: 200,
                    result: [],
                    nextKey: null,
                    error: null
                };
                let loading = true;
                let viewMore = false;
                if(offset){
                    resultObj.result = data.result;
                    resultObj.numberOfResults = data.numberOfResults;
                    loading = false;
                    viewMore = true;
                }
                setAdapterState({
                    loading: loading,
                    callApi: false,
                    viewMore: viewMore
                });
                callApi(context, record, limit, offset).then((data: Result) => {
                    data.result.map((item) => {
                        let dataObj: RecordType = item;
                        resultObj.result.push(dataObj);
                    });
                    let hasMore = true;
                    const newData = data.result;
                    if(newData.length <= 0 || newData.length < limit){
                        hasMore = false;
                    }
                    resultObj.numberOfResults = resultObj.result.length;
                    const newState = {
                        loading: false,
                        callApi: false,
                        viewMore: false,
                        hasMore: hasMore
                    };
                    setAdapterState(newState);
                    setData(resultObj);
                    if(callBack !== null){
                        callBack(resultObj);
                    }
                }).catch((data: Result) => {
                    const newState = {
                        loading: false,
                        callApi: false,
                        viewMore: false,
                        hasMore: false
                    };
                    resultObj.error = data.error;
                    setAdapterState(newState);
                    setData(resultObj);
                    if(callBack !== null){
                        callBack(resultObj);
                    }
                });
            }
            break;
        case 'jsforce':
            getData = () => {
                const conn = getConnection();
                if(!conn){
                    setAdapterState({
                        loading: false,
                        callApi: false
                    });
                    return;
                }
                let offset = state.RF_OFFSET;
                let loading = true;
                let viewMore = false;
                if(offset){
                    loading = false;
                    viewMore = true;
                }
                setAdapterState({
                    loading: loading,
                    callApi: false,
                    viewMore: viewMore
                });
                callApi(context, record).then((data: Result) => {
                    const newState = {
                        loading: false,
                        callApi: false,
                        viewMore: false
                    };
                    setAdapterState(newState);
                    setData(data);
                    if(callBack !== null){
                        callBack(data);
                    }
                });
            }
            break;
        case 'firebase':
            getData = () => {
                const database = getFirestore(firebaseApp);
                let loading = true;
                const resultObj: Result = {
                    numberOfResults: 0,
                    statusCode: 200,
                    result: [],
                    nextKey: null
                };
                let offset = state.RF_OFFSET;
                let viewMore = false;
                if(offset){
                    resultObj.result = data.result;
                    resultObj.numberOfResults = data.numberOfResults;
                    loading = false;
                    viewMore = true;
                }
                let dataLimit = state.RF_LIMIT;
                setAdapterState({
                    loading: loading,
                    callApi: false,
                    viewMore: viewMore
                });
                let constraints = [];
                
                let search = '';
                if(record.params.hasOwnProperty("search") && typeof(record.params.search) === "object"){
                    for(let key in record.params.search){
                        const value = record.params.search[key];
                        if(value && value.length > 0){
                            constraints.push(where(key, "==", value));
                        }
                    }
                }
                if(search.length <= 0){
                    if(offset){
                        constraints.push(startAfter(offset));
                    }
                }
                
                constraints.push(limit(dataLimit));
                const shipmentsRef = collection(database, "Shipments");;
                const q = query(shipmentsRef, ...constraints);
                getDocs(q).then((snapshot) => {
                    var nextKey = null;
                    snapshot.forEach((data) => {
                        let dataObj: RecordType = data.data();
                        resultObj.result.push(dataObj);
                        nextKey = data;
                    });
                    resultObj.nextKey = nextKey;
                    const newState = {
                        loading: false,
                        callApi: false,
                        viewMore: false
                    };
                    setAdapterState(newState);
                    setData(resultObj);
                    if(callBack !== null){
                        callBack(resultObj);
                    }
                }).catch(err => {
                    console.log("Error", err);
                    const newState = {
                        loading: false,
                        callApi: false,
                        viewMore: false
                    };
                    setAdapterState(newState);
                    setData(resultObj);
                    if(callBack !== null){
                        callBack(resultObj);
                    }
                });
            }
            break;
        default:
            break;
    }

    React.useEffect(() => {
        if(!state.callApi){
            return;
        }
        getData();
    });

    if(justData){
        return [data];
    }
    function setAdapterState(newState: any){
        newState = {
            ...state,
            ...newState
        };
        setState(newState);
    }
    return [ state.loading, data, state, setAdapterState ];
};

const callApi = (context: any, record: Record, limit = null, offset = null) => {
    return new Promise(function(resolve, reject){
        type RecordType = typeof record;
        let data: Result = {
            numberOfResults: 0,
            statusCode: 200,
            result: null,
            nextKey: null
        };
        let headers = {};
        let params: any = {};
        let method = 'GET';
        let requestData: any = {};
        if(typeof(record.method) === "string" && record.method.length > 0){
            method = record.method;
        }
        if(typeof(record.headers) === "object"){
            headers = record.headers;
        }
        if(typeof(record.params) === "object"){
            params = record.params;
        }
        if(typeof(record.data) === "object"){
            requestData = record.data;
        }
        let getData = () => {
            reject("Invalid data provider");
        };
        if(typeof(record.sObjectTypeName) !== "undefined" && record.sObjectTypeName.length > 0){
            params['sObjectTypeName'] = record.sObjectTypeName;
        }
        const authToken = localStorage.getItem("identity_token");
        const loginType = localStorage.getItem("login_type");
        if(authToken !== null){
            headers['x-user-identity'] = authToken;
        }

        switch(context){
            case 'salesforceapi':
                getData = () => {
                    headers = Object.assign(headers, {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    });
                    let sessionId = getSessionId();
                    if(sessionId && sessionId.length > 0 && loginType === "salesforce"){
                        headers['Authorization'] = "Bearer "+sessionId;
                    }
                    let route = '/services/data/v60.0'+record.url;
                    let namespace = getNamespace();
                    if(record.url && (record.url.startsWith("/v1") || record.url.startsWith("/v2") || record.url.startsWith("/v2"))){
                        if(namespace.length > 0){
                            namespace = namespace+"/";
                        }
                        record.url = record.url.replace("/v1", "/"+namespace+"v1");
                        route = '/services/apexrest'+record.url;
                    }
                    let domain = getParam("domain");
                    if(!domain || domain === "null" || domain.length <= 0){
                        domain = "";
                        if(process.env.REACT_APP_DATA_PROVIDER_URL){
                            domain = process.env.REACT_APP_DATA_PROVIDER_URL;
                        }
                    }
                    axios({
                        url: domain+route,
                        method: method,
                        headers: headers,
                        data: requestData,
                        params: params,
                        // cancelToken: cancelTokenSource.token
                    }).then(res => {
                        const data = res.data;
                        if(typeof(data) === "object" && typeof(data.result) === "object" && !Array.isArray(data.result)){
                            data.result = [data.result];
                        }
                        const resultObj: Result = data;
                        resolve(resultObj);
                    }).catch(err => {
                        if(err.response && err.response.data){
                            reject(err.response.data);
                        }
                        reject(err);
                    });
            
                    window.dispatchEvent(new Event("remoteAction"));
                }
                break;
            case 'apexadapter':
                getData = () => {
                    let route = record.url;
                    if(limit){
                        params['RF_LIMIT'] = limit;
                    }
                    if(offset){
                        params['RF_OFFSET'] = offset;
                    }
                    apexAdapter(method, route, requestData, params, headers, (result: any, event: any) =>{
                        if (!event || event.status) {
                            let data = JSON.parse(result);
                            if(typeof(data) === "object" && typeof(data.result) === "object" && !Array.isArray(data.result)){
                                data.result = [data.result];
                            }
                            const resultObj: Result = data;
                            resolve(resultObj);
                        }else{
                            let resultObj: Result = null;
                            try{
                                resultObj = JSON.parse(event.message);
                            }catch(e){
                                resultObj = {
                                    statusCode: 500,
                                    error: event.message
                                };
                            }
                            reject(resultObj);
                        }
                    });
                }
                break;
            case 'jsforce':
                getData = () => {
                    const conn = getConnection();
                    if(!conn){
                        return;
                    }
                    if(params.hasOwnProperty("query")){
                        conn.query(params.query, function(err, result) {
                            if (err) { return console.error(err); }
                            const data = {
                                numberOfResults: result.records.length,
                                statusCode: 200,
                                result: result.records,
                                nextKey: null
                            };
                            const resultObj: Result = data;
                            console.log("resultObj", resultObj);
                            resolve(resultObj);
                        });
                    }else if(params.hasOwnProperty("ids")){
                        conn.sobject(record.sObjectTypeName).retrieve(params.ids, function(err, account) {
                            if (err) { return console.error(err); }
                            const data = {
                                numberOfResults: 1,
                                statusCode: 200,
                                result: [account],
                                nextKey: null
                            };
                            const resultObj: Result = data;
                            console.log("resultObj", resultObj);
                            resolve(resultObj);
                        });
                    }else{
                        switch(method.toUpperCase()){
                            case 'GET':
                                break;
                            case 'POST':
                                conn.sobject(record.sObjectTypeName).create(requestData, function(err, ret) {
                                    if (err || !ret.success) { return console.error(err, ret); }
                                    const data = {
                                        numberOfResults: 1,
                                        statusCode: 200,
                                        result: [ret],
                                        nextKey: null
                                    };
                                    const resultObj: Result = data;
                                    console.log("resultObj", resultObj);
                                    resolve(resultObj);
                                });
                                break;
                            case 'PATCH':
                            case 'UPDATE':
                                conn.sobject(record.sObjectTypeName).update(requestData, function(err, ret) {
                                    if (err || !ret.success) { return console.error(err, ret); }
                                    const data = {
                                        numberOfResults: 1,
                                        statusCode: 200,
                                        result: [ret],
                                        nextKey: null
                                    };
                                    const resultObj: Result = data;
                                    console.log("resultObj", resultObj);
                                    resolve(resultObj);
                                });
                                break;
                            case 'DELETE':
                                conn.sobject(record.sObjectTypeName).destroy(requestData.Id, function(err, ret) {
                                    if (err || !ret.success) { return console.error(err, ret); }
                                    const data = {
                                        numberOfResults: 0,
                                        statusCode: 200,
                                        result: null,
                                        nextKey: null
                                    };
                                    const resultObj: Result = data;
                                    console.log("resultObj", resultObj);
                                    resolve(resultObj);
                                });
                                break;
                            default:
                                break;

                        }
                    }
                }
                break;
            default:
                break;
        }

        getData();
    });
};

export { DataProvider, DataContext, useDataProvider, callApi };